<template>
    <Fragment>
        <div class="footer" v-if="authToken && displayFooter">
            <div class="footer-buttons-container">
                <home-button @click="closeOverlayMenus" />
                <search-button @click="closeProfileOverlay" />
                <!--<quiz-button @click="closeOverlayMenus" />-->
                <outfit-button @click="closeOverlayMenus" />
                <profile-button @click="closeSearchOverlay" />
            </div>
        </div>
        <Search v-if="authToken" />
    </Fragment>
</template>

<script>
    import Mixins from '../../mixins/mixins.js';
    import { mapGetters } from 'vuex';
    import HomeButton from './home-button.vue';
    import SearchButton from './search-button.vue';
    import QuizButton from './quiz-button.vue';
    import OutfitButton from './outfit-button.vue';
    import ProfileButton from './profile-button.vue';
    import Search from '../search/search.vue';
    import { Fragment } from 'vue-fragment';

    export default {
        components: {
            HomeButton,
            SearchButton,
            QuizButton,
            OutfitButton,
            ProfileButton,
            Search,
            Fragment
        },
        computed: {
            ...mapGetters({
                authToken: 'auth/getAuthToken',
                displayFooter: 'footer/displayFooter',
            }),
        },
        methods:{
            closeOverlayMenus() {
                this.closeSearchOverlay();
                this.closeProfileOverlay();
            },
            closeSearchOverlay() {
                this.$store.commit('search/setSearchOpen', {
                    searchOpen: false
                });
            },
            closeProfileOverlay() {
                this.$store.commit('menu/setMenuOpen', {
                    open: false
                });
            }
        },
        mixins: [Mixins]
    }
</script>
